














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CloudflarePlayer extends Vue {
  @Prop({ default: "" }) videoId!: string;
  isVideoLoading = false;
  updateInterval: any = undefined;

  async mounted() {
    await this.checkIfVideoIsReady();

    if (this.isVideoLoading) {
      this.updateInterval = setInterval(async () => {
        await this.checkIfVideoIsReady();
      }, 2000);
    }
  }

  async checkIfVideoIsReady() {
    try {
      await Vue.axios.get(
        `https://videodelivery.net/${this.videoId}/manifest/video.mpd`
      );
      clearInterval(this.updateInterval);
      this.addVideoScript();
      this.isVideoLoading = false;
    } catch {
      this.isVideoLoading = true;
    }
  }

  beforeDestroy() {
    if (this.videoId) {
      const oldElement = document.getElementById(this.videoId);
      if (oldElement) {
        oldElement.remove();
      }
    }
  }

  addVideoScript() {
    if (this.videoId) {
      const script = document.createElement("script");
      script.setAttribute("data-cfasync", "false");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", this.videoId);
      script.setAttribute(
        "src",
        `https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=${this.videoId}`
      );

      document.head.appendChild(script);
    }
  }
}
